import { ref, computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

// [
//     {
//         "id": 1,
//         "name": "PutneyBridge",
//         "description": "Area of interest in study of Thames Tideway subsidence. Testing alerts system.",
//         "geometry": "[51.51, -0.175, 51.440, -0.27]",
//         "created": "2024-07-02T13:57:37.075028Z",
//         "updated": "2024-07-02T16:52:41.575270Z",
//         "centre_lat": 51.474999999999994,
//         "centre_lon": -0.2225,
//         "distance_of_interest": 0.03500000000000014,
//         "icon": "default"
//     },
// ]

// TODO - currently geometry OR centre_lat/centre_lon/distance_of_interest are
// required. This might be refl
interface BaseSite {
  id?: number;
  name: string;
  description?: string;
  created?: string;
  updated?: string;
  icon?: string;
  visible?: boolean;
}

interface GeometrySite extends BaseSite {
  geometry: string;
  // centre_lat?: never;
  // centre_lon?: never;
  // distance_of_interest?: never;
}

interface PointSite extends BaseSite {
  centre_lat: number;
  centre_lon: number;
  distance_of_interest: number;
  // geometry?: never;
}

export type Site = GeometrySite | PointSite;

// export interface Site {
//   id?: number
//   name: string
//   description: string
//   geometry: string
//   created?: string
//   updated?: string
//   centre_lat?: number
//   centre_lon?: number
//   distance_of_interest?: number
//   icon?: string
//   visible?: boolean

//   [key: string]: string | number | object | string[] | null | undefined | boolean
// }

export function useSites() {
  const sites = ref<Site[]>([]) // items is now Ref<Item[]>
  const getItems = async (): Promise<Site[]> => {
    const response = await fetch('/api/sites/?format=json')
    // Assert the response is OK
    if (!response.ok) {
      throw new Error('Failed to fetch Site')
    }
    // Assert the response is JSON
    if (!response.headers.get('content-type')?.includes('application/json')) {
      throw new Error('Invalid content type')
    }

    return await response.json()
  }

  const fetchItems = async () => {
    sites.value = await getItems()
    // sort the sites by name
    sites.value.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }))
    // remove any sites that have a 'visible' key set to false
    // sites.value = sites.value.filter((site) => site.visible !== false)

  }

  const postNewSite = async (site: Site) => {
    const authStore = useAuthStore();
    const csrfToken = await authStore.getCsrfToken(); // Await the async function
    const data = JSON.stringify(site)
    const response = await fetch('/api/sites/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRFToken': csrfToken,
      },
      body: data
    });
  
    if (!response.ok) {
      throw new Error('Failed to create Site');
    }
  
    return response;
  };
  

  const siteKeys = computed(() => {
    return sites.value.length > 0 ? Object.keys(sites.value[0]) : []
  })

  return { sites, fetchItems, siteKeys, postNewSite }
}
